export let dto_Customer = {
  CSID: Number,
  NIC: String,
  CusName: String,
  Email: String,
  PhoneNo: String,
  OTPCode: String,
  OTPTimeInMins: String,
  PushToken: String,
  DeviceInfo: String,
};

export let dto_CustomerAddress = {
  DefaultAdd1: String,
  DefaultAdd2: String,
  DefaultAdd3: String,
  AddressGuid: Number,
  PhoneNo: String,

  Location: String,
};

export let dto_CustomerAddressList = {
  dtoAddressList: Array,
};
